"use client";

import { useRef, useEffect } from "react";

export default function AutoplayVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    const container = containerRef.current;
    if (!video || !container) return;

    // Respect prefers-reduced-motion: don't autoplay for users who prefer less motion
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.4 },
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative aspect-video overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-blue-500/10"
    >
      <video
        ref={videoRef}
        controls
        muted
        preload="metadata"
        poster="/demo-poster.jpg"
        className="h-full w-full"
      >
        <source src="/demo-video.mp4" type="video/mp4" />
        <track kind="captions" src="/demo-captions-nl.vtt" srcLang="nl" label="Nederlands" />
      </video>
    </div>
  );
}
